import { render, staticRenderFns } from "./ProductRewardDetail.vue?vue&type=template&id=fb72e2ca&"
import script from "./ProductRewardDetail.vue?vue&type=script&lang=js&"
export * from "./ProductRewardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports